"use strict";

(function(z, Backbone){

    var NirItemsModel = Backbone.Model.extend({
        urlRoot: "/api/nir",
        // validation: {
        //     name: [{
        //         required: true,
        //         msg: Translator.trans("js.error_message_nirform_name_required")
        //     },{
        //         minLength: 4,
        //         msg: Translator.trans("js.error_message_orderform_customer_name_minlength")
        //     }],
        //     partNumber: [{
        //         required: true,
        //         msg: Translator.trans("js.error_message_nirform_pn_required")
        //     },{
        //         minLength: 4,
        //         msg: Translator.trans("js.error_message_nirform_pn_minlength")
        //     },{
        //         maxLength: 16,
        //         msg: Translator.trans("js.error_message_nirform_name_maxlength")
        //     }],
        //     commodityCode: [{
        //         required: false,
        //         minLength: 1,
        //         msg: Translator.trans("js.error_message_nirform_commodityCode_minlength")
        //     }],
        //     type: [{
        //         required: true,
        //         msg: Translator.trans("js.error_message_orderform_type_required")
        //     }],
        //     aquisitionPrice: [{
        //         fn: function(value) {
        //             if (!value) return Translator.trans("js.error_message_nirform_aquisitionPrice_min_value");
        //
        //             value = value.replace(',', '.');
        //
        //             if (isNaN(value) || parseFloat(value) < 0) {
        //                 return Translator.trans("js.error_message_nirform_aquisitionPrice_min_value");
        //             }
        //         }
        //     }]
        // },

        /**
         * Parses the response and returns the appropriate data
         * @param {Object} response The reponse
         * @return {Object} The data
         */
        parse: function(response){

            if( !_.isUndefined(response.data) ){

                return response.data;
            }

            return response;
        }
    });

    z.NirItemsModel = NirItemsModel;

})(window.z = window.z || {}, Backbone);
